var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"week-text-row flex between-xs"},_vm._l((_vm.weekdays),function(day,i){return _c('span',{key:i,staticClass:"week-text"},[_vm._v(_vm._s(day))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }